import React from 'react';
import styled from 'styled-components';

const HeaderStyled = styled('header')`
    width: 100%;
    padding: 30px 5%;
    position: absolute;
    z-index: 100;
`;

const AHref = styled('a')`
    display: inline-block;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    text-decoration: none;
    color: ${({theme}) => theme.colors.main};
    font-weight: 700;
    font-family: sans-serif;
`;

function Header() {
    return (
        <HeaderStyled>
            {renderTitle()}
        </HeaderStyled>
    );

    function renderTitle(){
        return (
            <AHref href='https://www.youthquake.it/' target="_blank" rel="noreferrer">
                YQ
            </AHref>
        )
    }

};


export default Header; 

